export class Phone {
  static format(number) {
    if (!number) {
      return number;
    }

    const str = number.replace(/[^0-9]/g, "");
    const phone = str.length >= 13 ? str.slice(2, 13) : str;
    const regex = /^([0-9]{2})([0-9]{4,5})([0-9]{4})$/;
    return phone.replace(regex, "($1) $2-$3");
  }

  static partialFormat(phoneString) {
    if (!phoneString) {
      return null;
    }
    return phoneString.replace(
      /^([0-9]{2})([0-9]{2})([0-9]{4,5})([0-9]{4})$/,
      "($2) ****-$4",
    );
  }

  static mask(phone) {
    let phoneNumber = phone.replace(/\D/g, "");
    phoneNumber = phoneNumber.replace(/^0/, "");

    if (phoneNumber.length > 10) {
      phoneNumber = phoneNumber.replace(
        /^(\d\d)(\d{5})(\d{4}).*/,
        "($1) $2-$3",
      );
    } else if (phoneNumber.length > 7 && phoneNumber.length <= 10) {
      phoneNumber = phoneNumber.replace(
        /^(\d\d)(\d{4})(\d{0,4}).*/,
        "($1) $2-$3",
      );
    } else if (phoneNumber.length > 2 && phoneNumber.length <= 7) {
      phoneNumber = phoneNumber.replace(/^(\d\d)(\d{0,5})/, "($1) $2");
    } else if (phone.trim() !== "") {
      phoneNumber = phoneNumber.replace(/^(\d*)/, "($1");
    }

    return phoneNumber;
  }

  static isValid(phone) {
    if (!phone) {
      return false;
    }

    let digits = phone.replace(/\D/g, "");

    if (digits.length === 12 || digits.length === 13) {
      if (digits.startsWith("55")) {
        digits = digits.slice(2);
      }
    }

    const landlineRegex = /^[1-9]{2}[2-5]\d{7}$/;
    const mobileRegex = /^[1-9]{2}9\d{8}$/;

    return landlineRegex.test(digits) || mobileRegex.test(digits);
  }
}
